import { createColumnHelper } from '@tanstack/react-table';
import { SegmentationConfig } from '../segmentationConfig.model';
import {
  SearchFilterOptions,
  StickyOptions
} from 'common/components/table/tableTypes';
import SegmentationRuleConfigTableActions from './segmentation-config-table-actions';
import { formatIsoDateTimeStringToDisplayDate } from 'common/utils/LEGACY_timeHelpers';
import { multiSelectFilter } from 'common/components/table/table-functions/filters';

const columnHelper = createColumnHelper<SegmentationConfig>();

export const getSegmentationRulesColumnDefs = () => [
  columnHelper.accessor((row) => row.name, {
    id: 'Name',
    header: () => 'Name',
    enableColumnFilter: true,
    filterFn: multiSelectFilter,
    meta: {
      searchFilterOptions: {
        isEnabled: true
      } as SearchFilterOptions
    },
    cell: (info) => (
      <div className="text-sm font-bold truncate">{info.getValue()}</div>
    )
  }),
  columnHelper.accessor((row) => row.segmentName, {
    id: 'Segment',
    header: () => 'Segment',
    enableColumnFilter: true,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.segmentationTypeName, {
    id: 'SegmentType',
    header: () => 'Segmentation Type',
    enableColumnFilter: true,
    filterFn: multiSelectFilter,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.ruleAccessTypeName, {
    id: 'ConfigType',
    header: () => 'Config Type',
    enableColumnFilter: true,
    filterFn: multiSelectFilter,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.statusName, {
    id: 'ConfigStatus',
    header: () => 'Config Status',
    enableColumnFilter: true,
    filterFn: multiSelectFilter,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.createdDateTime, {
    id: 'CreatedDate',
    header: () => 'Created Date',
    enableColumnFilter: false,
    cell: (info) => (
      <div className="text-sm truncate">
        {formatIsoDateTimeStringToDisplayDate(info.getValue())}
      </div>
    )
  }),
  columnHelper.accessor((row) => row.createdBy, {
    id: 'CreatedBy',
    header: () => 'Created By',
    enableColumnFilter: false,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.updatedDate, {
    id: 'UpdatedDate',
    header: () => 'Updated Date',
    enableColumnFilter: false,
    cell: (info) => (
      <div className="text-sm truncate">
        {formatIsoDateTimeStringToDisplayDate(info.getValue())}
      </div>
    )
  }),
  columnHelper.accessor((row) => row.updatedBy, {
    id: 'UpdatedBy',
    header: () => 'Updated By',
    enableColumnFilter: false,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.id, {
    id: 'Options',
    header: () => 'Options',
    enableColumnFilter: false,
    cell: (info) => (
      <SegmentationRuleConfigTableActions
        segmentationConfig={info.row.original}
      />
    ),
    minSize: 75,
    maxSize: 75,
    meta: {
      stickyOptions: {
        isEnabled: true,
        side: 'right'
      } as StickyOptions
    }
  })
];
